import { get, post, put, del } from 'utils/methods';

export function addNewCustomerApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/customer`, data, headers);
}

export function editCustomerApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/customer`, data, headers);
}

export function getCustomersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}customers`, data, headers);
}

export function getContactsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}contacts`, data, headers);
}

export function addNewContactApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/contact`, data, headers);
}

export function editContactApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/contact`, data, headers);
}

export function addNewAddressApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/address`, data, headers);
}

export function getAddressesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}addresses`, data, headers);
}

export function enableDisableAddressApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/address/status`, data, headers);
}

export function editAddressApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/address`, data, headers);
}

export function deleteAddressApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/address`, data, headers);
}

export function getOrdersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}orders`, data, headers);
}

export function addNewInvoiceApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/invoice`, data, headers);
}

export function generateCreditNoteInvoiceApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}credit-note-invoice`, data, headers);
}

export function addInvoiceDetailApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/add-invoices-detail`, data, headers);
}

export function getCustomerInvoicesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_FINANCE}get-invoices`, data, headers);
}

export function markInvoiceAsDoneApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/mark-invoices-as-done`, data, headers);
}

export function getCustomerTurnoverApi(id, headers, filter) {
    return get(`${process.env.REACT_APP_REST_ORDERS}customers/turnover/${id}/${filter}/[]`, null, headers);
}

export function downloadAllInvoicesApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/export`, data, headers);
}

export function getDownloadAllInvoicesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_FINANCE}exports`, data, headers);
}

export function createGroupedInvoiceApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/create-monthly_invoice-from-proforma`, data, headers);
}

export function regenarateProformaApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/invoice-manage`, data, headers);
}
